'use client';

import React from 'react';
import Image from 'next/image';

const HeroSection = (props) => {
  const { dict } = props;

  return (
    <section className='relative pb-32 px-4 overflow-hidden'>
      {/* Background Elements */}
      <div className='absolute inset-0 pointer-events-none'>
        <div className='absolute top-[120px] left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-accent/30 rounded-full blur-[180px]' />
        <div className='absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.04),transparent_60%)]' />
      </div>

      <div className='relative max-w-6xl mx-auto text-center'>
        {/* Main Logo */}
        <div className='flex justify-center'>
          <Image
            src='/images/logo_mini.png'
            alt='Техніка і гаджети'
            width={240}
            height={240}
            priority
            className='invert drop-shadow-[0_0_40px_rgba(0,102,255,0.35)]'
          />
        </div>

        {/* Brand wordmark */}
        <h1 className='text-5xl md:text-7xl font-oswald font-normal text-white mb-6 leading-[1.05] tracking-tight'>
          Техніка <span className='text-accent'>і</span> гаджети
        </h1>

        {/* Tagline */}
        <h2 className='text-2xl md:text-3xl font-oswald font-light text-gray-300 mb-8 leading-snug max-w-3xl mx-auto'>
          {dict.heroTitle}
        </h2>

        {/* Subtitle */}
        <p
          className='text-lg md:text-xl font-montserrat font-normal text-gray-400 mb-12 leading-relaxed max-w-2xl mx-auto'
          dangerouslySetInnerHTML={{ __html: dict.heroSubtitle }}
        />

        {/* Stat strip */}
        <div className='mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto'>
          {[
            { v: 'Enterprise | B2B | B2G', l: 'Distribution' },
            { v: '24/7', l: dict.headerContactUs },
            {
              v: (
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='mx-auto'
                  aria-label='Global'
                >
                  <circle
                    cx='12'
                    cy='12'
                    r='9'
                    stroke='currentColor'
                    strokeWidth='1.5'
                  />
                  <path
                    d='M3 12H21'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                  />
                  <path
                    d='M12 3C14.5 5.5 15.75 8.75 15.75 12C15.75 15.25 14.5 18.5 12 21C9.5 18.5 8.25 15.25 8.25 12C8.25 8.75 9.5 5.5 12 3Z'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              ),
              l: 'Ланцюг постачання (без обмежень)',
            },
          ].map((s) => (
            <div
              key={s.l}
              className='border border-white/10 bg-white/[0.02] rounded-2xl px-4 py-5 backdrop-blur-sm'
            >
              <div className='text-3xl font-oswald text-white flex items-center justify-center h-10'>
                {s.v}
              </div>
              <div className='text-xs font-montserrat text-gray-500 uppercase tracking-[0.18em] mt-1'>
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
